import '@inovua/reactdatagrid-community/index.css';
import React, { useState, useCallback } from 'react';
import {useHistory} from 'react-router-dom';
import ReactDataGrid from '@inovua/reactdatagrid-community';
import CheckBox from '@inovua/reactdatagrid-community/packages/CheckBox'
import { inject } from 'mobx-react';
import {gridStyle, filterValue, columns, defaultSortInfo} from '../grid-data/artist-grid-data';
import { ArtistGrid } from './artist-grid';


const MngArtists = ({artistStore, subscriptionStore}) => {
  const history = useHistory();
  const onSelectionChange = useCallback((selected) => {
    //Navigate to the form for that artist
    history.push(`/artist/view/${selected}`)
  }, [])
  const artistData = artistStore.items.map(item => {
    return {
        id: item._id,
        name: item.name,
        firstName: item.user?.firstName,
        lastName: item.user?.lastName,
        email: item.user?.userName || '',
        genre: item.genreLabel, // new genre label field makes accessing genres a easier
        status: item.status,
        joinDate: item.createdAt,
        updatedAt: item.updatedAt,
        catalogSize: item.songs.length,
        subscriptions: subscriptionStore.getSubscriptionsByArtist(item._id)

  }})
  return (
    <div>
      <div className="grid-x padding-top-1 padding-left-1">
          <div className="cell auto">
              <h3 data-ta="mngArtistsHeader">Manage Artists</h3>
          </div>
      </div>
      <ArtistGrid dataSource={artistData} onRowClick={(rowdata) => onSelectionChange(rowdata.id)}/>
    </div>
  );
}

const injectWithStores = inject('artistStore', 'subscriptionStore');

export default injectWithStores(
    ({artistStore, subscriptionStore}) => {
      
        return (
            <MngArtists artistStore={artistStore} subscriptionStore={subscriptionStore} />
        )
    })